// extracted by mini-css-extract-plugin
module.exports = {"legacyScreen":"admin-portal-frame__AdminPortalFrame__legacyScreen","historylessIFrame":"admin-portal-frame__AdminPortalFrame__historylessIFrame"};